<div class="decoration-container"
     [attr.data-size]="displaySize"
     [attr.data-type]="displayType"
     [attr.data-position]="position"
     [attr.data-disabled]="disabled"
     [attr.data-hidden]="hidden"
     *ngIf="!hidden && hasContent">

  <div class="decoration-content"
       [style.color]="displayColor"
       [style.background-color]="displayBackgroundColor">

    <!-- Icon Type -->
    <span *ngIf="displayType === 'Icon' && displayIcon" class="decoration-icon">
      {{ displayIcon }}
    </span>

    <!-- Text Type -->
    <span *ngIf="displayType === 'Text' && displayText" class="decoration-text">
      {{ displayText }}
    </span>

    <!-- Badge Type -->
    <div *ngIf="displayType === 'Badge'" class="decoration-badge">
      <span *ngIf="displayIcon" class="badge-icon">{{ displayIcon }}</span>
      <span *ngIf="displayText" class="badge-text">{{ displayText }}</span>
    </div>

    <!-- Dot Type -->
    <div *ngIf="displayType === 'Dot'" class="decoration-dot"></div>

    <!-- Radio Type -->
    <div *ngIf="displayType === 'Radio'" class="decoration-radio"></div>

    <!-- Button Type -->
    <div *ngIf="displayType === 'Button'" class="decoration-button">
      <span *ngIf="displayIcon" class="button-icon">{{ displayIcon }}</span>
    </div>

  </div>
</div>
